var product_images_mapper = {
    '4365499367490':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400164339778':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },

    '4400164536386':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

       
        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400164765762':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400164995138':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400165257282':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

       
        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400165552194':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4400165748802':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8883409453313':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4431804203074':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '4431804792898':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '6066307924149':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '6081956479157':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '6082373222581':{
        'Round+White Gold 1': 'Round+1.00 ct $3,600 to $5,999k+White Gold 1',
        'Round+White Gold 2':'Round+1.00 ct $3,600 to $5,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+1.00 ct $3,600 to $5,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+1.00 ct $3,600 to $5,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+1.00 ct $3,600 to $5,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+1.00 ct $3,600 to $5,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',
      
        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    }

// duplicate products
  ,
    '8055893065985':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8063385043201':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8063588172033':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },  
    '8067577184513':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8067618603265':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Radiant+White Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Radiant+White Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Radiant+Yellow Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Radiant+Yellow Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Radiant+Rose Gold 1': 'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Radiant+Rose Gold 2':'Radiant+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8336857432321':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    },
    '8338080465153':{
        'Round+White Gold 1': 'Round+0.50 ct $1,250 to $1,999k+White Gold 1',
        'Round+White Gold 2':'Round+0.50 ct $1,250 to $1,999k+White Gold 2',
        'Round+Yellow Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 1',
        'Round+Yellow Gold 2':'Round+0.50 ct $1,250 to $1,999k+Yellow Gold 2',
        'Round+Rose Gold 1': 'Round+0.50 ct $1,250 to $1,999k+Rose Gold 1',
        'Round+Rose Gold 2':'Round+0.50 ct $1,250 to $1,999k+Rose Gold 2',

        'Princess+White Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+White Gold 1',
        'Princess+White Gold 2':'Princess+0.50 ct $1,010 to $1,999k+White Gold 2',
        'Princess+Yellow Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 1',
        'Princess+Yellow Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Yellow Gold 2',
        'Princess+Rose Gold 1': 'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 1',
        'Princess+Rose Gold 2':'Princess+0.50 ct $1,010 to $1,999k+Rose Gold 2',

        'Oval+White Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Oval+White Gold 2':'Oval+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Oval+Yellow Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Oval+Yellow Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Yelllow Gold 2',
        'Oval+Rose Gold 1': 'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Oval+Rose Gold 2':'Oval+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Emerald+White Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Emerald+White Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Emerald+Yellow Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Emerald+Yellow Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Emerald+Rose Gold 1': 'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Emerald+Rose Gold 2':'Emerald+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Pear+White Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Pear+White Gold 2':'Pear+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Pear+Yellow Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Pear+Yellow Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Pear+Rose Gold 1': 'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Pear+Rose Gold 2':'Pear+0.50 ct $1,010 to $2,299k+Rose Gold 2',

        'Cushion+White Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+White Gold 1',
        'Cushion+White Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+White Gold 2',
        'Cushion+Yellow Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 1',
        'Cushion+Yellow Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Yellow Gold 2',
        'Cushion+Rose Gold 1': 'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 1',
        'Cushion+Rose Gold 2':'Cushion+0.50 ct $1,010 to $2,299k+Rose Gold 2',
    }
    
  };
